import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../components/dashboard/DashboardLayout";
import { PageHeader } from "../../components/dashboard/UI";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { Check, Bell } from "lucide-react";

const Notifications = () => {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  const load = () =>
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try {
      await api.post(`/notifications/${id}/read`);
      load();
    } catch {
      /* ignore */
    }
  };

  return (
    <DashboardLayout>
      <PageHeader
        eyebrow="Royal Ledger"
        title={t("dashboard.notifications")}
      />
      <div className="space-y-3">
        {items.map((n) => (
          <article
            key={n.id}
            className={`card-sharp p-5 flex items-start gap-4 ${n.read ? "opacity-60" : ""}`}
            data-testid={`notif-${n.id}`}
          >
            <span className={`status-dot mt-2 ${n.read ? "dot-muted" : "dot-accent"}`} />
            <div className="flex-1">
              <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#19A7E0]">
                {t(`notifTypes.${n.type}`)} · {new Date(n.created_at).toLocaleString()}
              </p>
              <p className="mt-1.5 text-base font-medium">{n.title}</p>
              <p className="mt-1.5 text-sm text-white/60 leading-relaxed">{n.body}</p>
            </div>
            {!n.read && (
              <button
                onClick={() => markRead(n.id)}
                data-testid={`notif-mark-read-${n.id}`}
                className="btn-ghost px-3 py-2 text-[10px] font-mono uppercase tracking-[0.18em] rounded-sm inline-flex items-center gap-1.5"
              >
                <Check className="w-3.5 h-3.5" /> {t("dashboard.markRead")}
              </button>
            )}
          </article>
        ))}
        {items.length === 0 && (
          <p className="text-sm text-white/50 flex items-center gap-2">
            <Bell className="w-4 h-4" /> {t("dashboard.noData")}
          </p>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Notifications;
